// Global Components
import * as React from 'react';

// Components
import InputLabel from '../InputLabel';

// Types
import type {
  $InputProps,
} from '../../../types';

type $Option = {
  id: string;
  label: string;
};

type $OptionalProps = {
  className?: string;
  disabled?: boolean;
  label?: string;
  labelClassName?: string;
  onChange?: (value: string) => unknown;
  placeholder?: string;
  required?: boolean;
  value?: null | string;
};

type $Props = $InputProps & $OptionalProps & {
  highlight: boolean;
  name: string;
  options: Array<$Option>;
};

class InputSelectView extends React.Component<$Props> {
  static defaultProps: $OptionalProps = {
    className: undefined,
    disabled: undefined,
    label: undefined,
    labelClassName: undefined,
    onChange: undefined,
    placeholder: undefined,
    required: undefined,
    value: undefined,
  };

  renderInput() {
    const {
      disabled,
      highlight,
      isValid,
      name,
      onChange,
      options,
      placeholder,
      required,
      setValue,
      value,
    } = this.props;

    return (
      <select
        className={`border-${highlight && !isValid ? 'red-600' : 'gray-400'} text-sm sm:text-base placeholder-gray-600 p-2 rounded-lg border w-full focus:outline-none focus:border-blue-400`}
        disabled={disabled}
        id={name}
        name={name}
        onBlur={(e) => {
          const newValue = e.currentTarget.value;

          if (onChange) {
            onChange(newValue);
          }

          setValue(newValue);
        }}
        required={required}
        style={{
          height: 42,
        }}
        value={value || undefined}
      >
        {value === null && (
          <option key={`${name}null`}>
            {placeholder}
          </option>
        )}
        {options.map((option: $Option) => (
          <option
            key={`${name}${option.id}`}
            value={option.id}
          >
            {option.label}
          </option>
        ))}
      </select>
    );
  }

  render() {
    const {
      className,
      label,
      labelClassName,
      name,
      required,
    } = this.props;

    return (
      <div className={`InputSelect ${className || ''}`}>
        <InputLabel
          className={labelClassName}
          label={label}
          name={name}
          required={required}
        />
        {this.renderInput()}
      </div>
    );
  }
}

export default InputSelectView;
